var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from "react";
import ReactSelect, { components, } from "react-select";
import variables from "../../theme/variables.module.scss";
import { Icon } from "../Icon";
import { Checkbox } from "../Checkbox";
import { Input } from "../Input";
import "./select.scss";
const DropdownIndicator = (props) => {
    const { selectProps: { menuIsOpen, isLoading }, } = props;
    if (!isLoading) {
        return (_jsx(components.DropdownIndicator, Object.assign({}, props, { className: `dropdownIndicator ${menuIsOpen ? "isOpen" : ""}` })));
    }
    return null;
};
const MultiValueRemove = (props) => {
    return (_jsx(components.MultiValueRemove, Object.assign({}, props, { children: _jsx(Icon, { iconName: "x", size: "extra-small" }) })));
};
const Option = (props) => {
    const { children, isSelected, isMulti } = props, rest = __rest(props, ["children", "isSelected", "isMulti"]);
    const dataOption = rest.data;
    const renderIcon = () => {
        if (typeof dataOption.icon === "string") {
            return _jsx(Icon, { iconName: dataOption.icon, size: "small" });
        }
        return dataOption.icon;
    };
    if (isMulti) {
        return (_jsxs(components.Option, Object.assign({}, rest, { isMulti: true, className: isSelected ? "isSelected" : "", isSelected: isSelected, children: [_jsx(Checkbox, { checked: isSelected, size: "small" }), _jsxs("div", { className: "option-wrapper", children: [dataOption.icon && renderIcon(), children] })] })));
    }
    return (_jsxs(components.Option, Object.assign({}, rest, { className: isSelected ? "isSelected" : "", isMulti: false, isSelected: isSelected, children: [_jsxs("div", { className: "option-wrapper", children: [dataOption.icon && renderIcon(), children] }), isSelected ? (_jsx("div", { className: "checkIcon", children: _jsx(Icon, { color: "primary", iconName: "check", size: "extra-small" }) })) : ("")] })));
};
const Control = (props) => {
    const { children } = props, rest = __rest(props, ["children"]);
    const { isLoading } = rest.selectProps;
    return (_jsx(components.Control, Object.assign({}, rest, { className: `${isLoading ? "control-isLoading" : ""}`, children: children })));
};
const ValueContainer = (props) => {
    const { children, selectProps } = props, rest = __rest(props, ["children", "selectProps"]);
    const { error } = selectProps;
    return (_jsxs(components.ValueContainer, Object.assign({}, rest, { selectProps: selectProps, children: [React.Children.map(children, (child) => {
                if (child)
                    return child;
                return rest.hasValue ? (_jsx("div", { className: "single-value", children: selectProps.getOptionLabel(rest.getValue()[0]) })) : (_jsx("div", { className: "placeholder", children: selectProps.placeholder }));
            }), error && _jsx(Icon, { className: "error-icon", iconName: "exclamation-circle" })] })));
};
const MenuList = (props) => {
    const { selectProps } = props, rest = __rest(props, ["selectProps"]);
    const { onInputChange, inputValue, onMenuInputFocus, withSearch = false, searchPlaceholder = "Search", } = selectProps;
    // Copied from source
    const ariaAttributes = {
        "aria-label": selectProps["aria-label"],
        "aria-labelledby": selectProps["aria-labelledby"],
    };
    return (_jsxs("div", { children: [withSearch && (_jsx(Input, Object.assign({ style: {
                    width: "100%",
                    boxSizing: "border-box",
                    padding: 10,
                    border: "none",
                    borderBottom: "1px solid lightgrey",
                }, iconName: "search", autoCorrect: "off", autoComplete: "off", spellCheck: "false", type: "text", value: inputValue, onChange: (e) => {
                    onInputChange(e.currentTarget.value, {
                        prevInputValue: inputValue,
                        action: "input-change",
                    });
                }, onMouseDown: (e) => {
                    var _a;
                    e.stopPropagation();
                    (_a = e.target) === null || _a === void 0 ? void 0 : _a.focus();
                }, onTouchEnd: (e) => {
                    var _a;
                    e.stopPropagation();
                    (_a = e.target) === null || _a === void 0 ? void 0 : _a.focus();
                }, onFocus: onMenuInputFocus, placeholder: searchPlaceholder, "aria-autocomplete": "list" }, ariaAttributes))), _jsx(components.MenuList, Object.assign({}, rest, { className: `${rest.className} select__menu`, selectProps: selectProps }))] }));
};
const Select = (props) => {
    const { options, onChange, placeholder, noOptionsMessage, label = "", value, isMulti, onBlur, name = "select", defaultValue = [], error = false, isRequired = false, isLoading = false, helpText = "", dataTestId = "tecma-select", fluid, searchPlaceholder = "Search option...", isSearchable = false, hideSelectedOptions = false, sortBySelectedOptions = false, isClearable = false, closeMenuOnSelect = false, maxItemSelectedToShow = 3, } = props;
    const containerRef = useRef(null);
    const [isInputFocused, setIsInputFocused] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const customStyles = {
        placeholder: (styles, { selectProps }) => (Object.assign(Object.assign({}, styles), { color: variables.onGeneralSub, fontWeight: "400", fontSize: "0.875rem", display: "inline", fontFamily: "Lato, sans-serif", lineHeight: "1.5rem", textOverflow: "ellipsis", whiteSpace: "nowrap", overflowX: "clip", overflow: "hidden", flexWrap: "nowrap", maxWidth: selectProps.error ? "calc(100% - 0.5rem)" : "unset" })),
        control: (styles) => (Object.assign(Object.assign({}, styles), { borderRadius: variables.borderRadiusElement, height: "2.5rem", minWidth: "10rem", boxShadow: "none", borderColor: error ? variables.semanticDanger : variables.generalBorder, borderWidth: "1px", "&:hover": {
                borderColor: error ? variables.semanticDanger : variables.accent,
                borderWidth: "1px",
            }, "&:focus": {
                borderColor: error ? variables.semanticDanger : variables.accent,
                borderWidth: "1px",
            } })),
        menuList: (styles) => (Object.assign(Object.assign({}, styles), { margin: "0", boxShadow: "0px 2px 18px 0px rgba(100, 100, 100, 0.25)", borderRightWidth: "0.5rem", padding: "0", maxHeight: "18rem", borderRadius: variables.borderRadiusExternal, "&::-webkit-scrollbar ": {
                width: "4px",
                backgroundColor: "#dbe1e1",
                borderRadius: "100px",
            }, "&::-webkit-scrollbar-thumb ": {
                backgroundColor: "#969e9eAA",
                borderRadius: "100px",
            } })),
        option: (styles, { isDisabled, isFocused, isSelected, isMulti: isMultiProp }) => (Object.assign(Object.assign({}, styles), { fontSize: "14px", fontWeight: "400", display: "flex", height: "3rem", padding: "0 1rem", position: "relative", alignItems: "center", fontFamily: "Lato, sans-serif", justifyContent: isMultiProp ? "initial" : "space-between", backgroundColor: isFocused ? variables.generalHover : undefined, color: isDisabled
                ? variables.neutral80
                : isSelected && !isMultiProp
                    ? variables.accent
                    : variables.onGeneral, ".checkIcon": {
                svg: {
                    width: "1rem",
                    height: "1rem",
                    color: variables.accent,
                },
            }, "&:active": {
                backgroundColor: variables.primaryLight,
            } })),
        valueContainer: (styles, { selectProps }) => (Object.assign(Object.assign({}, styles), { textOverflow: "ellipsis", whiteSpace: "nowrap", overflowX: "clip", overflow: "unset", flexWrap: "nowrap", display: selectProps.isMulti ? "inline" : "flex", alignSelf: "center", padding: `0 ${selectProps.error ? "1.5rem" : "0"} 0 0.5rem` })),
        singleValue: (styles) => (Object.assign(Object.assign({}, styles), { color: variables.onGeneral, fontFamily: "Lato, sans-serif", fontWeight: "400", fontSize: "14px", display: "inline-block" })),
        multiValue: (_, { selectProps }) => ({
            display: "inline-flex",
            color: variables.onHover,
            minHeight: "22px",
            maxWidth: `calc(100% / ${selectProps.maxItemSelectedToShow} - 1rem)`,
            marginRight: "10px",
            backgroundColor: variables.accentLight,
            borderRadius: variables.borderRadiusInternal,
            ":not(:first-of-type)": {},
        }),
        multiValueLabel: () => ({
            fontWeight: "500",
            fontFamily: "Lato, sans-serif",
            fontSize: "0.75rem",
            fontStyle: "normal",
            lineHeight: "1rem",
            whiteSpace: "nowrap",
            overflow: "hidden",
            padding: "0.25rem 0.5rem",
            paddingRight: "10px",
            textOverflow: "ellipsis",
            alignSelf: "center",
            marginRight: "-12px",
        }),
        multiValueRemove: (styles) => (Object.assign(Object.assign({}, styles), { transition: "background-color 300ms, stroke 300ms", svg: {
                width: "1rem",
            }, ":hover": {
                backgroundColor: "transparent",
                cursor: "pointer",
            } })),
        input: (styles) => (Object.assign(Object.assign({}, styles), { margin: "0", paddingTop: "0", fontSize: "14px", paddingBottom: "0", marginLeft: "5px" })),
        indicatorSeparator: () => ({
            display: "none",
        }),
        indicatorsContainer: (styles) => (Object.assign(Object.assign({}, styles), { svg: {
                color: "#808080",
            } })),
    };
    const handleOnChange = (newValue) => {
        setIsInputFocused(false);
        if (onChange) {
            onChange(newValue);
        }
    };
    const Options = () => {
        var _a;
        if (isMulti) {
            const optionsSelected = sortBySelectedOptions ? value : [];
            const optionsWithSelectedOption = [
                ...(defaultValue !== null && defaultValue !== void 0 ? defaultValue : []),
                ...optionsSelected,
                ...((_a = options === null || options === void 0 ? void 0 : options.filter((option) => {
                    return (!(defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.find((optionSelect) => optionSelect.value === option.value)) &&
                        (sortBySelectedOptions
                            ? !value.find((optionSelect) => optionSelect.value === option.value)
                            : true));
                })) !== null && _a !== void 0 ? _a : []),
            ];
            return optionsWithSelectedOption;
        }
        return options;
    };
    const onDomClick = (e) => {
        var _a, _b;
        const menu = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(".select__menu");
        if (!((_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target)) || !menu || !menu.contains(e.target)) {
            setIsInputFocused(false);
            setInputValue("");
        }
    };
    useEffect(() => {
        document.addEventListener("mousedown", onDomClick);
        return () => {
            document.removeEventListener("mousedown", onDomClick);
        };
    }, []);
    return (_jsxs("div", { "data-testid": dataTestId, className: "tecma-select", children: [label && _jsx("span", { className: "tecma-select-label", children: `${label} ${isRequired ? "*" : ""}` }), _jsx("div", { ref: containerRef, className: `tecma-select-box ${fluid ? "fluid" : ""}`, children: _jsx(ReactSelect, { value: value, classNamePrefix: "select", onMenuOpen: () => {
                        document.body.style.overflow = "hidden";
                    }, onMenuClose: () => {
                        document.body.style.overflow = "auto";
                    }, isLoading: isLoading, components: {
                        Option,
                        MultiValueRemove,
                        DropdownIndicator,
                        Control,
                        MenuList,
                        ValueContainer,
                    }, inputValue: inputValue, options: Options(), styles: customStyles, isMulti: isMulti, closeMenuOnSelect: closeMenuOnSelect, isClearable: isClearable, searchPlaceholder: searchPlaceholder, hideSelectedOptions: hideSelectedOptions, noOptionsMessage: () => noOptionsMessage, placeholder: placeholder, isSearchable: false, withSearch: isSearchable, onChange: handleOnChange, onInputChange: (val) => setInputValue(val), onMenuInputFocus: () => setIsInputFocused(true), name: name, maxItemSelectedToShow: maxItemSelectedToShow, onBlur: (e) => onBlur === null || onBlur === void 0 ? void 0 : onBlur(Object.assign(Object.assign({}, e), { target: Object.assign(Object.assign({}, e.target), { name: name !== null && name !== void 0 ? name : "" }) })), error: error, menuIsOpen: isInputFocused || undefined,
                    isFocused: isInputFocused || undefined }) }), error && helpText && _jsx("span", { className: "help-text", children: helpText })] }));
};
export default Select;
